import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getRequest } from '../services/templeService'
import useNotifications from './useNotifications'

/**
 * Hook for fetching a temple request
 * @param {number} requestId ID to fetch
 * @returns {Object} request
 */
const useRequest = (requestId) => {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [request, setRequest] = useState()

  useEffect(() => {
    let isCurrent = true
    if (requestId) {
      setRequest()
      getRequest(requestId)
        .then((response) => {
          if (isCurrent) {
            setRequest(response.data)
          }
        })
        .catch((err) => {
          if (isCurrent) {
            error(
              t('hooks.errors.gettingTempleRequest', {
                defaultValue: `Error getting temple request: ${err.message || ''}`,
                message: err.message || '',
              }),
              err
            )
          }
        })
    } else {
      setRequest(null)
    }
    return () => {
      isCurrent = false
    }
  }, [error, requestId, t])

  return request
}

export default useRequest
